export default __webpack_public_path__ + "static/apple-4c6322d369192178c991de29556521dd.png";